import { SALES_SIGNUP } from '../constants/signupConstants'; // @ts-expect-error ts-migrate(7016) FIXME: This will be migrated in the next phase

import { gettingStartedLink } from '../utils/urls'; // @ts-expect-error ts-migrate(7016) FIXME: This will be migrated in the next phase

import { getViaRedirectionParam } from '../utils/redirectUtils';
import salesExperiences from './salesExperiences';
import marketingExperiences from './marketingExperiences';
import servicesExperiences from './servicesExperiences';
import trialExperiences from './trialExperiences';
import cmsExperiences from './cmsExperiences';
import { maybeGetSalesReplacementRedirectUrl, shouldNotSkipSetupUi } from './salesIntentLinkData';
export const gettingStartedRedirect = () => ({
  redirectPath: gettingStartedLink,
  redirectParams: {
    enroll: 'true'
  }
});
export const maybeGetReplacementRedirectUrl = (redirectUrl, {
  portalId,
  queryParams,
  signupIntent,
  signupType,
  shouldNotRedirectToSalesInstallationPage = false
}) => {
  switch (signupType) {
    case SALES_SIGNUP:
      return maybeGetSalesReplacementRedirectUrl({
        portalId,
        redirectUrl,
        queryParams,
        signupIntent,
        shouldNotRedirectToSalesInstallationPage
      });

    default:
      return redirectUrl;
  }
};
export const getDecorationParams = ({
  intentLink,
  signupIntent,
  signupType,
  survey,
  queryParams
}) => {
  return Object.assign({}, survey.crmExperience && {
    crmExperience: survey.crmExperience
  }, {}, signupType && {
    via: getViaRedirectionParam(signupType)
  }, {}, signupType === SALES_SIGNUP && Object.assign({}, shouldNotSkipSetupUi({
    redirectUrl: intentLink,
    queryParams,
    signupIntent
  }) && {
    redirect: intentLink
  }));
};
export const onboardingRedirectChecks = [...salesExperiences, ...marketingExperiences, ...servicesExperiences, ...trialExperiences, ...cmsExperiences];